import { useEffect, useState } from 'react'

export const isOnline = (): boolean => {
  return navigator.onLine
}

export const isOffline = (): boolean => {
  return !navigator.onLine
}

export const useOfflineStatus = () => {
  const [isOfflineStatus, setOffline] = useState(isOffline)

  useEffect(() => {
    const setOfflineStatus = () => {
      setOffline(true)
    }

    const setOnlineStatus = () => {
      setOffline(false)
    }

    window.addEventListener('offline', setOfflineStatus)
    window.addEventListener('online', setOnlineStatus)
    return () => {
      window.removeEventListener('offline', setOfflineStatus)
      window.removeEventListener('online', setOnlineStatus)
    }
  }, [])

  return isOfflineStatus
}
